import { strict } from 'assert';
import { algoliasearch } from 'algoliasearch';
import aa from 'search-insights';

strict(process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID);
strict(process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY);

export const algoliaClient = algoliasearch(
  process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
);

const PRODUCTION_INDEX_MAP = {
  INTEGRATIONS: 'integration_catalog',
  POSTS: 'posts',
  CASE_STUDIES: 'case_studies',
  RESOURCES: 'resources',
} as const;

const DEV_INDEX_MAP = {
  INTEGRATIONS: 'DEV_integration_catalog',
  POSTS: 'DEV_posts',
  RESOURCES: 'DEV_resources',
  CASE_STUDIES: 'DEV_case_studies',
} as const;

// Ensure that the dataset and algolia index are the same
export const INDEX_MAP =
  process.env.NEXT_PUBLIC_SANITY_DATASET === 'production'
    ? PRODUCTION_INDEX_MAP
    : DEV_INDEX_MAP;

// Map document types to Algolia index names
export const getIndexNameForType = (type: string): string | null => {
  switch (type) {
    case 'integration':
      return INDEX_MAP.INTEGRATIONS;
    case 'post':
      return INDEX_MAP.POSTS;
    case 'resource':
      return INDEX_MAP.RESOURCES;
    case 'caseStudy':
      return INDEX_MAP.CASE_STUDIES;
    default:
      return null;
  }
};

/**
 * Algolia Insights API
 * @see https://www.algolia.com/doc/api-client/methods/insights/
 */
export const algoliaInsightsClient = aa;
algoliaInsightsClient('init', {
  appId: process.env.NEXT_PUBLIC_ALGOLIA_APPLICATION_ID,
  apiKey: process.env.NEXT_PUBLIC_ALGOLIA_SEARCH_KEY,
  useCookie: true,
});
